import React from "react";
import { DocumentoPastaEntidade } from "./../../../entidades";
import { Link } from "react-router-dom";

import { FaFolderOpen } from "react-icons/fa";

interface IProps {
  pastas: Array<DocumentoPastaEntidade>;
}

export const ListaPasta: React.FC<IProps> = ({
  pastas
}) => {

  function renderPastaTabela() {
    return pastas.map(
      (pasta: DocumentoPastaEntidade, index: number) => {
        return (
          <tr key={index}>
            <td style={{ "width": "50px" }}>
              <FaFolderOpen color={"#ffc107"} size={26} />
            </td>
            <td>
              <Link
                className={"btn btn-link"}
                to={`/documentos/${pasta.OID_DOCUMENTO_PASTA}`}
              >
                {pasta.NOM_PASTA}
              </Link>
            </td>
          </tr>
        );
      }
    );
  };

  return (<>{renderPastaTabela()}</>);
}
